import {type FunctionalComponent, h} from '@stencil/core';
import {chatWidgetKeywords} from './utils';

interface ISupportChatWidget {
  term?: string;
  language?: string;
  country?: string;
}

export const SupportChatWidget: FunctionalComponent<ISupportChatWidget> = (props) => {

    const {
      term,
      language,
      country
    } = props;

    function capitalizeFirstLowerRest(str?: string): string {
        if (!str) return '';
        const lower = str.toLowerCase();
        return lower.charAt(0).toUpperCase() + lower.slice(1);
    }

    const formattedTerm = capitalizeFirstLowerRest(term);

    return (
      (
        language === 'zh'
          ? chatWidgetKeywords[language]?.[country]?.includes(formattedTerm)
          : chatWidgetKeywords[language]?.includes(formattedTerm)
      ) || chatWidgetKeywords['default']?.includes(formattedTerm)
    ) ? (
        <div class="support-chat-widget" data-query={formattedTerm} data-language={props.language} data-country={country}>
          <contact-us-chat-main intent=''></contact-us-chat-main>
        </div>
      ) : '';
};